// @ts-nocheck
import { useImportRepository } from '../repositories';

export interface ImportJob {
  id: string;
  fileName: string;
  entityType: string;
  status: string;
  totalRows: number;
  processedRows: number;
  errorRows: number;
  errors: string[];
  createdAt: string;
  completedAt: string | null;
}

export interface ExportJob {
  id: string;
  entityType: string;
  format: string;
  status: string;
  downloadUrl: string | null;
  createdAt: string;
  completedAt: string | null;
}
// TODO: useExportJobs and useExportData need dedicated queries/mutations not
// covered by the Import repository. Remove compat imports once an Export
// repository exists.
import { useCompatQuery, useCompatMutation } from './useApolloCompat';
import { EXPORT_JOBS_QUERY, EXPORT_DATA_MUTATION } from '../graphql/operations';

export function useImportJobs(variables?: { page?: number; perPage?: number; status?: string }) {
  const repo = useImportRepository();
  return repo.useList(variables);
}

// TODO: Migrate to repository pattern once an Export repository exists.
export function useExportJobs(variables?: { page?: number; perPage?: number }) {
  return useCompatQuery(EXPORT_JOBS_QUERY, { variables, notifyOnNetworkStatusChange: true });
}

export function useStartImport() {
  const repo = useImportRepository();
  const { create, loading, error } = repo.useCreate();
  return {
    mutate: (input: any) => create(input),
    mutateAsync: (input: any) => create(input),
    isPending: loading,
    loading,
    error,
  };
}

// TODO: Migrate to repository pattern once an Export repository exists.
export function useExportData() {
  return useCompatMutation(EXPORT_DATA_MUTATION, {
    refetchQueries: [{ query: EXPORT_JOBS_QUERY }],
  });
}
